import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid'

export const studentReviews = [
    {
      id: 1,
      fullName: 'Nguyễn Hồng Hạnh',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Mentor siêu siêu siêu có tâm ạ :D Khóa học tuy nặng nhưng chị Ánh vẫn luôn hỗ trợ hết mình, BTVN luôn được chữa tỉ mỉ và chi tiết. Em cảm ơn chị Ánh nhiều ạ',
      avatar: 'NHH'
    },
    {
      id: 2,
      fullName: 'Trần Thị Thu Hà',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Chị Ánh là 1 giảng viên rất tâm huyết và có kiến thức sâu nên dù là 1 người trái ngành, kiến thức về BA là con số 0 nhưng mình vẫn có thể theo được mọi người trong lớp. Em cũng muốn cảm ơn chị vì đã support em rất nhiều trong quá trình học tập ạ.',
      avatar: 'TTTH'
    },
    {
      id: 3,
      fullName: 'Hoàng Ngọc Tú',
      rating: 5,
      course: 'BA thực chiến OFF',
      classroom: 'In-Person',
      review: 'Một lớp học vô cùng áp lực nhưng sẽ giúp mọi người hiểu sâu về nghiệp vụ ạ. Mình ám ảnh với 2 câu nói của chị trong các lớp học: thôi chết lại cháy giáo án và hiểu thật chưa :d, chị sẽ hỏi cho đến khi học viên hiểu mới thôi thế nên là chị thường xuyên lố giờ, rồi sau đó chị lại đi bổ sung thêm buổi nhưng k thu $$$ nhé :) Chị Ánh cũng tạo ra được 1 cộng đồng các bạn BA thường giúp đỡ nhau trong nghề, tạo ra các buổi workshop chia sẻ của các Anh/Chị đi trước trong nghề. Nên học nhé các bạn :)',
      avatar: 'HNT'
    },
    {
      id: 4,
      fullName: 'Nguyễn Ngọc Bảo Hiên',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khóa học cực có ích, chị Ánh dạy và chữa bài rất rất kỹ luôn ạ',
      avatar: 'NGBH'
    },
    {
      id: 5,
      fullName: 'Nguyễn Dịu',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'cô dạy nhiệt tình và dễ hiểu',
      avatar: 'ND'
    },
    {
      id: 6,
      fullName: 'Đỗ Minh Ngọc',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khóa học hay và bổ ích. Kiến thức hệ thống và logic. Đối với người đã có thời gian làm việc ở ngoài như em thì đây là cơ hội để rà soát và điều chỉnh lại cách làm việc của bản thân ạ',
      avatar: 'DMN'
    },
    {
      id: 7,
      fullName: 'Nguyễn Minh Thu',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Mình nghe nói về khóa học của chị Ánh đã lâu, mà lớp nào cũng hết chỗ nhanh quá, chờ mất nửa năm mới được học chị Ánh. Tới lúc được học thì mình thấy rất là xứng đáng với số tiền đã bỏ ra. Chị Ánh tuần nào cũng sửa bài và nhận xét cho mình rất kỹ qua từng bài tập. Nhờ khóa học cùng chị Ánh mà mình hiểu hơn về công việc BA mình đang làm, giao tiếp với team tốt hơn, viết tài liệu rõ ràng và dễ hiểu hơn trước rất nhiều. 1 năm sau khi học chị Ánh thì mình đang du học bậc Thạc sĩ ngành Chuyển đổi số ở Singapore với học bổng toàn phần rồi. Quyết định chuyển sang làm BA và theo học lớp của chị Ánh là điều mà mình sẽ không bao giờ hối tiếc :D Cảm ơn chị Ánh và các mentor nhiều ạ! <3',
      avatar: 'NMT'
    },
    {
      id: 8,
      fullName: 'Nguyễn Thị May',
      rating: 5,
      course: 'BA thực chiến OFF',
      classroom: 'In-Person',
      review: 'Khóa học thực sự chất lượng, chứa rất nhiều tâm huyết của chị Ánh, nội dung slide, bài giảng được soạn chi tiết, thường xuyên được cải tiến, cập nhật, kết hợp bài tập nhóm và bài tập cá nhân, được chữa bài, góp ý theo từng case study cá nhân. Ngoài kiến thức, kỹ năng thì mình còn cảm nhận được sự nhiệt huyết, yêu nghề của chị Ánh, điều đó giúp mình có thêm nhiều động lực theo nghề hơn. Em cảm ơn chị Ánh :))',
      avatar: 'NTM'
    },
    {
      id: 9,
      fullName: 'Phan Thị Thu Trang',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khóa học rất chất lượng và chi tiết. Cái em thích là khóa không chú trọng vào dạy tool như các trung tâm khác mà tập trung dạy về tư duy nhiều hơn, dạy sát với thực tế khi đi làm ạ.',
      avatar: 'PTTT'
    },
    {
      id: 10,
      fullName: 'Nguyễn Thị Hồng Nhung',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Sau khi học khoá học, em nắm được và thực hành các kiến thức mà BA cần khi đi làm. Khi đi làm BA, có thể ứng dụng các phần đã học vào công việc như viết tài liệu, đọc nghe hiểu các trao đổi trong công việc như diagram, ERD,… Đặc biệt khi có vấn đề cần xem lại thì vẫn có thể xem lại các tài liệu đã học',
      avatar: 'NTHN'
    },
    {
      id: 11,
      fullName: 'Dương Thị Bích Thu',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khóa học có rất nhiều kiến thức về nhiều nghiệp vụ của BA. Qua khóa học thì mình nắm rõ được quy trình, cách làm, cách tư duy khi làm BA giúp mình nhiều trong công việc. Mình học trái ngành nên quá trình cũng hơi vất vả xíu. Các bạn học nhớ xem tài liệu cô gửi trước khi vào học nha.',
      avatar: 'DTBT'
    },
    {
      id: 12,
      fullName: 'Hoàng Thị Tuyến',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Đăng ký khóa học vào tháng 06.2022 nhưng do bận một số việc cá nhân nên phải lùi lại tham gia khóa học vào tháng 08.2022. Sau khi học xong khóa học mình cảm nhận khóa học sẽ phù hợp cho các bạn fresher cho đến những bạn từ 1-3y kinh nghiệm làm BA. Bởi, khóa học cho mọi người cái nhìn tổng quan về BA rồi dạy đến các technic cần dùng/hay dùng, các loại diagram thông dụng mà BA thường dùng khi làm việc nên các bạn có vài năm kinh nghiệm BA trước đó vẫn phù hợp nha (nếu lăn tăn có thể đọc . Điều mình thích nhất ở khóa học, đầu tiên là c Ánh sẽ tập trung vào việc dạy tư duy để mình hiểu (còn việc dùng các tool, platform để biểu diễn tư duy thì mk phải chủ động tự học sử dụng trước, sẽ k dạy trên lớp), để dành time focus vào truyển đạt kiến thức và tư duy cho mọi người (vậy mà nhiều hôm c vẫn phải dạy cố cho kịp bài ấy). Điều mình thích thứ 2 là làm BTap chấm 1-1, sẽ hơi cực nhưng mình có thể thấy được lỗ hổng tư duy của mình. Điều mình thích thứ 3 là sự tâm lý và linh hoạt của c Ánh đó là c linh động chữa bài cho các bạn nộp muộn sau khi kết thúc khóa học, tuy nhiên điều kiện cần là mọi người phải chủ động làm BT (chứ c Ánh k giục đâu, có thân thì lo nha). Nhưng mà mọi người nên học và làm BTap theo đúng tiến độ thì sẽ tốt hơn, nhớ bài và hiểu bài hơn, chứ để lâu bị quên kiến thức (đến lúc làm BT pahri xem lại video, kiến thức…lại ấy). Cuối cùng, k thể bỏ qua đó là sau khóa học c Ánh vẫn hỗ trợ rất nhiệt tình nếu như có thắc mắc gì k hiểu (nhưng nhớ là phải chủ động tìm hiểu trước khi hỏi nữa nha). Thêm nữa, thi thoảng c Ánh còn tổ chức các buổi chia sẻ, giải đáp thắc mắc cho học viên (c Ánh còn mời thêm các a/c có tiếng trong giới BA mà c biết nữa cơ – xịn nhắm). Một điều mình muốn lưu ý với mọi người trước khi đăng ký khóa học: 1 là tập TD thường xuyên nhằm giữ sức khỏe tốt để tiếp thu kiến thức 1 cách tốt nhất (lúc học khóa t8 mình bị ốm mấy tuần nên nhọc lắm). 2 là trong khoảng time học dành khoảng 2h mỗi ngày để học + làm BTVN thì khi tham gia khóa học sẽ hiệu quả.',
      avatar: 'HTT'
    },
    {
      id: 13,
      fullName: 'Trịnh Thu Trang',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Em thấy chị Ánh và chị Ngọc rất có tâm và dạy chi tiết dễ hiểu. Phân phối chương trình thì em k có ý kiến vì em nonIT ko biết gì nên có như nào học như vậy ạ. Khóa học này dành cho các bạn thực sự có thời gian, chăm chỉ và có tư duy ok còn ai đi làm thì ko nên học lắm vì nếu như vậy sẽ ko tận dụng hết quyền lợi của mình như làm BTVN và sửa bài. Em cảm thấy giá trị khóa học này đem lại xứng đáng với học phí ạ! Em cảm ơn chị Ánh và chị Ngọc nhiều nhé!',
      avatar: 'TTT'
    },
    {
      id: 14,
      fullName: 'Nguyễn Quỳnh Trang',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'em thấy khóa học của chị rất chi tiết và tổng quan. tuy nhiên hiện tại em đi làm thì công việc cũng chỉ mới được làm 1 phần rất nhỏ trong những gì chị dạy, vì thế nên em khá tiếc ạ',
      avatar: 'NQT'
    },
    {
      id: 15,
      fullName: 'Đỗ Quỳnh Anh',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Giảng viên dạy rất có tâm, bài giảng có hệ thống rõ ràng, chữa từng bài tập kĩ càng. Khi tham gia khóa học cần dành 1 khoảng thời gian mỗi ngày để xem lại lý thuyết và làm bài tập, bởi khóa khá nặng, tuần nào cũng là 1 bài tập lớn. Khóa học có tính ứng dụng cao và giảng viên cũng nhiệt tình giải đáp các thắc mắc liên quan 😍👍',
      avatar: 'DQA'
    },
    {
      id: 16,
      fullName: 'Thảo Phương Trần',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Giảng viên dạy hay, chi tiết, đưa ra nhiều case. Ngoài ra còn được tham gia vào nhóm alumni, được anh chị chia sẻ nhiều. Bạn sẽ cần phải chăm học và nghiền ngẫm khá nhiều',
      avatar: 'TPT'
    },
    {
      id: 17,
      fullName: 'Vũ Thị Diệu',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Biết được khóa học của chị Ánh là do khi đang lướt cmt mọi người recommend khóa BA nào xịn nhất, thì giữa 1 rừng seeding mình vô tình thấy được khóa chị Ánh. Và bằng 1 cách kì diệu nào đó đã chốt đơn khóa này luôn trong lần đầu tiên xem page Learning =))) Thực sự thì đến tận bây giờ mình chưa bao giờ hối hận mà chỉ cảm thấy may mắn và biết ơn khi biết đến chị Ánh và khóa học (Tháng 3/2023). - Về khóa học: chi tiết, đầy đủ, siêu nhiều kiến thức và giá hạt dẻ :v Thời lượng khóa học là 2 tháng nhưng với mình thì mình phải học đến 4 tháng (1 tháng trước khi học để nghe record và đọc silde, 2 tháng học vs chị Ánh và 1 tháng sau học tổng kết lại kiến thức). Đây không phải là khóa học mà dành cho người chỉ muốn cưỡi ngựa xem hoa cho xong đâu ạ, nhiều kiến thức mà khi đi làm mình mới nhận ra là "À, chỗ này chị Ánh có dạy như này rồi" và lại lôi record cũ ra xem lần nữa. - Về mentor chị Ánh: người chị hiền lành, tâm huyết với khóa học, kiến thức và thi thoảng bất lực khi mà hỏi là không thấy học viên trả lời =)))) Điều em thấy hay nhất ở cách dạy của chị Ánh là khi dạy thì chị hay lồng ghép các case thực tế, các tình huống chị đã làm và trải qua để mọi người hiểu rõ ràng hơn. Và hơn hết, dù đã kết thúc khóa học nhưng chị luôn sẵn sàng trả lời mọi tin nhắn thắc mắc, cho lời khuyên với bất cứ ai hỏi. - Về góp ý cho khóa học: vì kiến thức nặng nên em thấy ví dụ ở giữa khóa học mình nên có 1 khoảng break để học viên hồi sức lại ạ :v Cuối cùng thì highly recommend cho mọi người học khóa này nhé (không hối tiếc đâu ạ) và mong chờ các khóa học về các domain khác của chị Ánh ạ (chắc e phải đóng họ dài dài ở đây rồi). <3 <3 <3',
      avatar: 'VTD'
    },
    {
      id: 18,
      fullName: 'Trần Thị Như Nguyệt',
      rating: 5,
      course: 'BA thực chiến OFF',
      classroom: 'In-Person',
      review: 'Khóa học phù hợp với người mới đã làm công việc BA, còn đối với những bạn chưa từng làm BA sẽ cần 1 sự cố gắng nỗ lực và tập trung lớn. Kiến thức chị Ánh dạy đều rất hữu dụng và sát với thực tế công việc, chị dạy rất tâm huyết và chữa bài cho từng người rất chi tiết. Có thể nói kinh nghiệm có trong gần 1 năm làm BA của mình cũng chưa thể bằng kinh nghiệm có được trong hơn 2 tháng tham gia khóa học. Rất cảm ơn chị Ánh và hy vọng trung tâm ngày càng phát triển để có thêm nhiều khóa học chất lượng!',
      avatar: 'TTNN'
    },
    {
      id: 19,
      fullName: 'Hoàng Văn Trung',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: '1. Nội dung khóa học: Cực kỳ đầy đủ, chi tiết. Các bài học được sắp xếp có hệ thống và logic để đảm bảo học viên có thể bắt tay ngay vào công việc BA. Phần em cảm thấy thích và hứng thú nhất trong quá trình học là về ERD, Database và SQL. 2. Giảng viên: Chị Ánh rất tâm huyết, nhiệt tình với học viên, chữa bài tập rất chi tiết, tỉ mỉ đến khi nào ổn mới thôi. Nhờ những kiến thức kỹ năng mà chị Ánh đã dạy cũng như hướng dẫn trong suốt hành trình, em đã có sự tự tin để ứng tuyển vào các job BA và đã may mắn đậu phỏng vấn, tìm được công việc tốt ngay khi kết thúc khóa học. * Tổng kết: Các bạn học viên mới chỉ cần chăm chỉ, quyết tâm học và làm hết bài tập thì chắc chắn sẽ làm được BA',
      avatar: 'HVT'
    },
    {
      id: 20,
      fullName: 'Trần Thảo',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khoá học giúp e được hệ thống lại kiến thức về BA, bổ sung nhiều kiến thức và tư duy thiếu sót trong quá trình làm BA. Trước khi tham gia khoá học, em khá mông lung về nghề BA, nhưng sau khi học c Ánh thì thấy rõ hơn rất nhiều về con đường đang đi. Chính vì hệ thống kiến thức khá nặng nên quá trình hoàn thành được khoá học nếu không chịu khó làm BT từng tuần sẽ rất khó theo. Ngay cả sau khi kết thúc học rồi thì nhiều kiến thức e vẫn phải xem đi xem lại nhiều lần để hiểu hơn cách xử lý.',
      avatar: 'TT'
    },
    {
      id: 21,
      fullName: 'Phan Linh',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'E thấy khoá học có kiến thức đầy đủ chi tiết + tài liệu cực kỳ nhiều, hv nào học kỹ sẽ có đủ kiến thức và tự tin để xin việc E mong muốn sau mỗi buổi học c bổ sung thêm bài test nhỏ, với mục đích: - Kiểm tra hv hiểu đúng hướng chưa, nếu sai thì kịp sửa lại trc khi làm bt (câu hỏi dạng trắc nghiệm vs các ví dụ sát thực tế) - Định hướng các đầu mục để hv dễ tổng hợp kiến thức hơn. Vì lượng kiến thức và tài liệu quá nhiều nên hv dễ bị mông lung, bỏ sót (câu hỏi kiểu đánh đố lý thuyết)',
      avatar: 'PL'
    },
    {
      id: 22,
      fullName: 'Đặng Thị Hương',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Trước khi tham gia khóa học BA, em đang trong trạng thái hoang mang, mơ hồ, chưa biết phải làm những công việc gì khi phân tích và phải làm như thế nào. Nhưng sau khi tham gia khóa học, được học đầy đủ về quy trình phân tích, em đã tiếp thu được rất nhiều kiến thức, kinh nghiệp quý báu của chị, giờ đây em đã tự tin hơn rất nhiều và em cũng đang áp dụng nó vào chính công việc hiện tại của em và nó đem lại hiệu quả rất tốt, mặc dù cty cũng chưa có quy trình cụ thể cho BA. Em cảm ơn chị rất nhiều ạ! Khóa học đã đưa ra các quy trình phân tích rất cụ thể và chi tiết, có hướng dẫn thực hành đầy đủ, mọi vướng mắc đều được hỗ trợ nhiệt tình, mặc dù trong quá trình học em cũng bận không làm được bài tập đầy đủ nhưng các kiến thức c chỉ dạy em đều hiểu và tiếp thu được. Em cảm ơn chị rất nhiều ạ!',
      avatar: 'DTH'
    },
    {
      id: 23,
      fullName: 'Nguyễn Anh Thư',
      rating: 5,
      course: 'IT cơ bản cho BA',
      classroom: 'Online',
      review: '3 anh chị giảng giải rất tận tình và dễ hiểu ạ. Khóa học khá nặng kiến thức nhưng nếu chăm chỉ em tin là mình sẽ được mở mang rất nhiều tri thức bổ ích, thật sự quá xứng đáng với số tiền bỏ ra ạ.',
      avatar: 'NAT'
    },
    {
      id: 24,
      fullName: 'Hoàng Thị Huế',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Học xong lớp học của chị Ánh cảm thấy mình ngày càng lú vì quá nhiều kiến thức luôn ạ. Kiến thức chị Ánh dạy rất thực tế và cần thiết cho công việc, có thể áp dụng ngay nếu đang làm BA và dễ dàng ghi nhớ hơn. Còn nếu chưa tìm hiểu job trước khi học thì lúc học sẽ dễ bị ngợp kiến thức và cần phải luyện tập nghe video rất nhiều. Các chị giảng dạy nhiệt tình và chữa bài chi tiết. Nhưng vì kiến thức quá nhiều nên khi học phải tập trung, chăm làm bài tập, chăm nghe video và phải kiên trì 1xxxxx lần đúng như lời cảnh báo của chị Ánh ngay từ khi đăng ký khóa học thì mới học được thật :)))) Rất cảm ơn các chị đã giảng dạy và hỗ trợ chúng em trong và sau quá trình học ạ',
      avatar: 'HTH'
    },
    {
      id: 25,
      fullName: 'NGUYỄN VÂN ANH',
      rating: 5,
      course: 'BA thực chiến OFF',
      classroom: 'In-Person',
      review: 'Khoá học đã giúp mình có được cái nhìn thực tiễn hơn cho công việc BA trong giai đoạn phải nhận một dự án mới mà chưa có kiến thức thực tế. Tuy những kiến thức đã học từ chị Ánh mình chưa có cơ hội được sử dụng hết nhưng khi gặp vấn đề về nghiệp vụ, chỉ cần xem lại giáo trình cũng giúp mình phần nào để có giải pháp. Khoá học sẽ phù hợp với các bạn đã làm BA nhưng muốn hệ thống hoá kiến thức một cách chuẩn chỉ và tăng mindset của BA. Tuy nhiên, với các bạn chưa từng học qua hoặc làm về BA thì nên xem trước tài liệu để khi chị Ánh giảng cũng như chăm chỉ làm bài tập để khoá học được hiệu quả hơn.',
      avatar: 'NVA'
    },
    {
      id: 26,
      fullName: 'Vũ Thị Hồng',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Thật đúng đắn khi đã trao gửi niềm tin đúng chỗ. Chị giáo siêu có tâm. Luôn luôn support học trò nhiều nhất có thể. Để học được khóa của chị mà phải chờ mấy tháng mới thấy chị mở để đăng ký. Mở cái là em phải đăng ký ngay. Thế mà chưa tới 24h sau khi chị mở đã thấy không cho đăng ký nữa vì đã đủ học viên. Quá nhanh, quá nguy hiểm! High recommend khóa học nhé!',
      avatar: 'VTH'
    },
    {
      id: 27,
      fullName: 'Lê Thị Thanh Thuỳ',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Em rất hài lòng với chất lượng khóa học BA ONL của chị Ánh. Trước khi khóa học bắt đầu em được nghe video và đọc tài liệu trước rồi mới bắt đầu khóa học. Học onl còn đc nghe lại video nữa, học như vậy em thấy rất ngấm kiến thức. Trong thời gian ngắn cũng đã học đc nhiều nhiều thứ về BA. Thật sự rất hữu ích đối với em. Em rất hài lòng với mô hình học này.',
      avatar: 'LTTT'
    },
    {
      id: 28,
      fullName: 'Hoàng Thị Ngọc Thảo',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khóa học cung cấp nhiều kiến thức hơn so với bên khác mình học, sẽ có rất nhiều lý thuyết chứ không phải chỉ dạy cách dùng tool, và mình đi phỏng vấn fresher cũng có bên yêu cầu vẽ Activity và Sequence Diagram như trong khóa học. Không khí lớp khá trầm nên dễ mất tập trung. Nếu đăng ký thì mọi người nên sắp xếp thời gian để làm bài tập và được review cho hiểu rõ thực tế, nếu không thì nên bảo lưu cho đỡ phí. Thời gian học mình bận không làm được bài tập nên giờ tiếc lắm.',
      avatar: 'HTNT'
    },
    {
      id: 29,
      fullName: 'Vũ Thúy Chinh',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Học xong khóa học từ 1 người trái ngành em hiểu được các bước mà 1 BA cần làm. Chị giảng và chữa bài rất tỉ mỉ ạ',
      avatar: 'VTC'
    },
    {
      id: 30,
      fullName: 'Đào Thị Thu Hằng',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khóa học rất thiết thực đối với e ạ.',
      avatar: 'DTTH'
    },
    {
      id: 31,
      fullName: 'Lê Thị Hồng Nhung',
      rating: 5,
      course: 'BA thực chiến OFF',
      classroom: 'In-Person',
      review: 'Em đi học lớp BA của c vào thời điểm em nhen nhóm chuyển sang làm BA. Nhờ lớp học của c mà em được biết các cv BA ntn, được trang bị kiến thức để tự tin đi phỏng vấn, có đủ dũng cảm để quyết định chuyển ngành =)). Khoá học của c được học xuyên suốt quá trình làm 1 dự án mà khi đi làm thực tế sẽ khó được thực hành như vậy',
      avatar: 'LTHN'
    },
    {
      id: 32,
      fullName: 'Lê Thị Nga',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Mình tốt nghiệp Học viện tài chính, đi làm ở công ty công nghệ nên có tìm hiểu về BA và được bạn giới thiệu học chị Ánh, rất nhiều bạn khác của mình cũng rcm học chị Ánh. Chưa bắt đầu khóa học đã được nhận rất nhiều tài liệu: Slide bài giảng, record của khóa trước, BTVN của các bạn khóa trước làm, có review của chị Ánh... có thể xem trước và học dần trước để hiểu hơn và đỡ bỡ ngỡ hơn khi vào học chính thức. Cách thức chị Ánh giảng dạy cũng tỉ mỉ, cẩn thận và dễ hiểu, từ cơ bản đến nâng cao, đặc biệt là với đứa tay ngang trái ngành chuyển sang như mình cũng dễ tiếp cận và hiểu hơn về hệ thống. Kiến thức khá là nhiều nên đôi khi mình cũng thấy ngợp và hơi mông lung, cho đến giờ đi làm rồi nhưng thỉnh thoảng vẫn xem lại record, chỗ nào không hiểu có thể nhắn lên nhóm lớp để chị Ánh hoặc các bạn trong nhóm hỗ trợ. Học xong thì nên làm BTVN hoặc áp dụng luôn vào công việc đang làm thì sẽ có nhiều kỹ năng kinh nghiệm hơn, chị Ánh chữa bài tập cũng rất chi tiết. Lớp onl của mình còn được tổ chức các buổi offline để trao đổi làm bài tập nhóm. Nói chung mình khá là hài lòng với khóa học này và dự kiến học thêm nâng cao về tech, chưa kể giá học phí của chị Ánh rất rất mềm so với các trung tâm khác, rcm các bạn có ý định học thì đăng ký nhanh không hết slot.',
      avatar: 'LTN'
    },
    {
      id: 33,
      fullName: 'Nguyễn Thị Xinh',
      rating: 5,
      course: 'IT cơ bản cho BA',
      classroom: 'Online',
      review: '5 Sao cho chất lượng khóa IT cơ bản cho BA nhưng 2 sao cho học viên vì để mà thấm được chắc phải học lại khóa này 1 2 lần nữa do khối lượng kiến thức khá nhiều và khó. Tính ra qua bên khác thì phải tách khóa này thành 2 3 khóa khác nhau để bán ý.',
      avatar: 'NTX'
    },
    {
      id: 34,
      fullName: 'Cao Thị Hương Nga',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Thông qua khóa học BA thực chiến, em rất cảm ơn chị Ánh và chị Ngọc đã cho bọn em những kiến thức rất hữu ích về BA. BA là gì? BA cần làm gì trong dự án phát triển phần mềm? Bên cạnh đó, bản thân em xuất phát từ kinh tế nên khi mới đầu tiếp xúc với Data, các từ chuyên ngành (API, SQL...) thì em lại chưa thể hiểu được sâu nó là gì, việc vận hành thực tế nó như thế nào. Em đọc lý thuyết nhưng em lại chưa biết cách để áp dụng nó, cũng như việc em việc tài liệu quá detail, vẽ màn hình em sẽ mắc những lỗi logic data giữa các màn. Chắc em sẽ phải xem lại khóa học nhiều lần và tổng kết là khóa học mà các chị cung cấp rất hữu ích đối với em <3',
      avatar: 'CTHN'
    },
    {
      id: 35,
      fullName: 'Phan Thùy Linh',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khoá học của chị Ánh rất hữu ích, đặc biệt là đối với những bạn mới làm quen với BA. Đi làm 1 thời gian về xem lại video chị Ánh giảng mới dần thấm được kiến thức trong khoá học. Chị Ánh rất tận tâm, giảng giải tỉ mỉ, giải đáp đầy đủ. Cảm ơn chị Ánh về những kiến thức rất hay ạ',
      avatar: 'PTL'
    },
    {
      id: 36,
      fullName: 'Trương Thị Phượng',
      rating: 5,
      course: 'BA thực chiến OFF',
      classroom: 'In-Person',
      review: 'Khóa học nhiều kiến thức, được hướng dẫn kĩ những phần trọng tâm. Giảng viên nhiệt tình hỗ trợ và giải đáp thắc mắc. Để học được hiệu quả nhất thì phải dành nhiều thời gian làm bài tập và ôn lại. Người đang đi làm như mình thì hơi khó sắp xếp thời gian, nên lúc học nhiều phần chưa ngấm. Sau này kết thúc khóa học mới đọc và ngẫm lại thì thấy thấm.',
      avatar: 'TTP'
    },
    {
      id: 37,
      fullName: 'Phạm Thị Hương',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Trước khi học chị Ánh mình đã mơ về viễn cảnh mình và nghề BA nắm tay nhau tung tăng. Sau đó mình hừng hực khí thế đăng ký...và rồi cái rụp 🥲 học được nửa khoá thì xin bảo lưu vì thực sự bị ngợp bởi lượng kiến thức khủng lồ. Mà lỡ bỏ 2 buổi coi như xong, vắt chân lên cổ không đuổi kịp. Từ đó trở đi đêm nào mình cũng mơ về khoá học của c Ánh còn dang dở. Nên các bạn xác định học thật nghiêm túc và thật chăm thật chăm thật chăm thì học mới hiệu quả nhé.',
      avatar: 'PTH'
    },
    {
      id: 38,
      fullName: 'Nguyễn Khánh Linh',
      rating: 5,
      course: 'IT cơ bản cho BA',
      classroom: 'Online',
      review: 'Khoá học thật sự rất có ích với những BA không có background IT, chuyển từ ngành khác như em. Ngay từ 3 buổi đầu tiên, em đã vỡ ra khá nhiều điều mà trước đây đi làm từng gặp, nhưng không để ý, hoặc dev nói nhưng chưa hiểu. Đây thật sự là một khoá học THẬT SỰ CẦN cho em, và hiện tại em vẫn đang cày lại những buổi đã học để nghiền ngẫm lại kiến thức. Highly recommend!',
      avatar: 'NKL'
    },
    {
      id: 39,
      fullName: 'Vũ Thị Thanh Huyền',
      rating: 5,
      course: 'IT cơ bản cho BA',
      classroom: 'Online',
      review: 'Khóa học giúp em hiểu rõ và tư duy tốt hơn những kiến thức về dữ liệu, data,...nhiều kiến thức khi học tại khóa BA em chưa hiểu hết nhưng sang khóa này em đã hiểu được .',
      avatar: 'VTTH'
    },
    {
      id: 40,
      fullName: 'Phạm Trung Nghĩa',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: '- Nội dung khoá học đầy đủ, kiến thức, có sự cập nhật. - Vì khá nhiều thông tin trong buổi học nên để có một buổi học tốt, nên chuẩn bị trước bằng cách xem video và đọc slide. - Giảng viên hay tương tác với học viên cả trong giờ học và khi chữa bài tập về nhà, rất chi tiết.',
      avatar: 'PTN'
    },
    {
      id: 41,
      fullName: 'Phạm Quốc Đạt',
      rating: 5,
      course: 'BA thực chiến OFF',
      classroom: 'In-Person',
      review: '',
      avatar: 'PQD'
    },
    {
      id: 42,
      fullName: 'VŨ THỊ DỊU',
      rating: 5,
      course: 'IT cơ bản cho BA',
      classroom: 'Online',
      review: 'Với chi phí và thời lượng này, khó có thể tìm được khoá học nào chất lượng như vậy. Vô tình xem được video hướng dẫn của chị trên YouTube đã đưa em đến khoá học này. Em cảm nhận được sự tận tâm, nhiệt huyết của chị Ánh và các Anh/chị trong từng tin nhắn phản hồi, từng bài giảng,… Cám ơn M2MBA đã hỗ trợ em nhiệt tình trong suốt thời gian qua 💖',
      avatar: 'VTD2'
    },
    {
      id: 43,
      fullName: 'Võ Thị Hồng Ngọc',
      rating: 5,
      course: 'IT cơ bản cho BA',
      classroom: 'Online',
      review: '- Điểm cộng: + Kiến thức thực tiễn, giúp nâng cao chuyên môn  + Mentor nhiệt tình hỗ trợ => Học xong khóa này vỡ lẽ ra rất nhiều điều, mapping với thực tế đi làm, tự tin hơn khi tranh luận với dev :D - Điểm trừ: + Nội dung khá nặng và dài, cần nhiều thời gian để ngấm dần + Khóa chỉ phù hợp với bạn đã và đang làm BA, nếu chưa có kinh nghiệm học dễ bị ngợp và khó hiểu => khó phát huy hiệu quả',
      avatar: 'VTHN'
    },
    {
      id: 44,
      fullName: 'Phạm Hương',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khóa học "tận dụng" chị Ánh đúng nghĩa 😁 Nhờ chị hay lấy ví dụ thực hành khi học và gần như cầm tay chữa từng lỗi một trong bài tập mà mình được rèn tư duy, "thông não" rất nhiều!!',
      avatar: 'PH'
    },
    {
      id: 45,
      fullName: 'Luyện Linh Chi',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'nếu có 10 sao em cũng vote. khoá học dạy kỹ lắm mặc dù nhiều kiến thức nên phải tự nghiền ngẫm nhiều lần mới chắc được. c Ánh có lưu lại tài liệu cho các khoá học nên rất tốt khi mình vừa làm mở tài liệu ra nghiền lại những phần chưa chắc.',
      avatar: 'LLC'
    },
    {
      id: 46,
      fullName: 'Nguyễn Hải Hà',
      rating: 5,
      course: 'IT cơ bản cho BA',
      classroom: 'Online',
      review: '',
      avatar: 'NHH2'
    },
    {
      id: 47,
      fullName: 'Phạm Thị Xuân',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: '',
      avatar: 'PTX'
    },
    {
      id: 48,
      fullName: 'Hương Nhi Cao',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Tuy video bài học có thời lượng khá dài và nhiều khi có quãng lặng, khoá học vẫn cung cấp đầy đủ kiến thức để bắt đầu ngành BA. Khoá học chất lượng ở điểm được thực hành case study đi theo từng nội dung chính gắn với công việc chính của BA nên dễ hình dung được BA cần làm những gì và như thế nào. Hơn nữa là được thực hành và nhận feedback kỹ từ chị Ánh nên rút ra được nhiều bài học hơn. Chị Ánh cũng chia sẻ các tình huống/trải nghiệm khác nhau của BA trong từng ngành khác',
      avatar: 'HNC'
    },
    {
      id: 49,
      fullName: 'Hoàng Thị Phương Thảo',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Chị Ánh giảng bài rất kỹ, trả lời tất cả các câu hỏi của học viên trong buổi học cũng nhu các câu hỏi trên nhóm zalo của lớp. Chị thường xuyên đưa ra các ví dụ thực tế cũng như nhắc lại kiến thức nhiều lần để đảm bảo các bạn có thể follow được bài học. Một điều mình rất ấn tượng ở khoá học là chị sửa bài rất kỹ, chị sửa bài cho tất cả các bạn có nộp bài, và comment chi tiết trên từng lỗi sai của mỗi người.',
      avatar: 'HTPT'
    },
    {
      id: 50,
      fullName: 'Đỗ Minh Ngọc',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: '',
      avatar: 'DMN2'
    },
    {
      id: 51,
      fullName: 'Hoàng Thanh Tâm',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Nội dung khóa học bao gồm nhiều kĩ năng. Lượng kiến thức khá nhiều, rất chi tiết. Các chị mentor chữa bài rất chi tiết',
      avatar: 'HTT2'
    },
    {
      id: 52,
      fullName: 'Bạch Thị Thảo Nguyên',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Nội dung bài giảng đầy đủ, chi tiết, chị Ánh giảng bài tỉ mỉ và có những ví dụ rõ ràng để hiểu bài. Khuyến khích mn khi học nên dành thời gian nghe lại vì mình thấy càng nghe càng hiểu được thêm nhiều điều.',
      avatar: 'BTTN'
    },
    {
      id: 53,
      fullName: 'Nguyễn Thu Giang',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: '- Nội dung bài giảng chi tiết, dễ hiểu, có hệ thống, bám sát thực tiễn - Giáo viên nhiệt tình, tận tâm, chữa bài tập kỹ (điều mà ko phải trung tâm nào cx làm đc) - Học phí phù hợp, rẻ hơn nhiều so với nhiều trung tâm dạy P/S: Em cảm ơn chị nhiều vì nhờ có khóa học này của chị, em mới hiểu được các kiến thức không chỉ liên quan đến nghiệp vụ cơ bản BA, mà còn những kiến thức, kỹ năng và cách tư duy tốt đằng sau những sản phẩm ứng dụng mình dùng trong cuộc sống hàng ngày. Em tin rằng không chỉ với nghề BA, mà cách tư duy mindset Why chị dạy sẽ giúp ích rất nhiều trong các lĩnh vực khác của cuộc sống. Đặc biệt hơn nữa, trong chuỗi ngày tháng em đang bơ vơ lạc lõng về hướng nghiệp cho chính bản thân mình, khóa học này chính là luồng ánh sáng mới chiếu rọi lại vào cuộc đời của em, khiến em tìm lại được kim chỉ nam của chính bản thân mình. Văn em không tốt lắm nên có thể hơi lan man, nhưng em chỉ muốn nói là em cảm ơn chị rất rất nhiều!!!',
      avatar: 'NTG'
    },
    {
      id: 54,
      fullName: 'Thao vy',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Biết đến khóa học và được tham gia khóa học là một may mắn trong hành trình theo đuổi nghề BA của mình. Nội dung khóa học rất bổ ích và súc tích, cùng với sự giảng dạy kỹ càng và chấm chữa bài tập nhiệt tình từ giảng viên giúp những bạn đang làm BA như mình hệ thống lại kiến thức, hiểu sâu hơn về nghề BA và rèn luyện tư duy logic. Bên cạnh đó, khóa học như kim chỉ nam giúp xóa tan những sự mông lung về nghề BA đối với những bạn mới sắp làm BA.',
      avatar: 'TV'
    },
    {
      id: 55,
      fullName: 'Trần Thị Tuyết',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Khoá học thống kê nội dung chi tiết, dễ theo dõi, chị Ánh rất rất nhiệt tình và giảng dễ hiểu',
      avatar: 'TTT2'
    },
    {
      id: 56,
      fullName: 'Nguyễn Vân Anh',
      rating: 5,
      course: 'IT cơ bản cho BA',
      classroom: 'Online',
      review: '',
      avatar: 'NVA2'
    },
    {
      id: 57,
      fullName: 'Nguyễn Vân Anh',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: '',
      avatar: 'NVA3'
    },
    {
      id: 58,
      fullName: 'Trương Quang Phổ',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: '',
      avatar: 'TQP'
    },
    {
      id: 59,
      fullName: 'Lê Thị Ngọc',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: '',
      avatar: 'LTN2'
    },
    {
      id: 60,
      fullName: 'Trần Đình Thanh',
      rating: 5,
      course: 'BA thực chiến OFF',
      classroom: 'In-Person',
      review: '',
      avatar: 'TDT'
    },
    {
      id: 61,
      fullName: 'Hồ Thanh Tĩnh',
      rating: 5,
      course: 'BA thực chiến ON',
      classroom: 'Online',
      review: 'Cảm ơn chị Ánh rất nhiều. Khóa học chất lượng, phù hợp với mình, một người low tech và non-IT chuyển ngành. Sau khóa học mình đã có thể tự handle dự án, hiểu sâu hơn về ngành BA cũng như áp dụng được vào công việc với vai trò IT BA trong dự án.',
      avatar: 'HTT3'
    }
  ];

export function renderStars(rating: number) {
  return (
    <span role="img" aria-label={`${rating} trên 5 sao`} className="inline-flex items-center">
      {[...Array(5)].map((_, i) => (
        <StarIconSolid
          key={i}
          aria-hidden="true"
          className={`h-5 w-5 ${i < rating ? 'text-m2-secondary' : 'text-m2-surface-highest'}`}
        />
      ))}
    </span>
  )
}
